<template>
    <div style="width: 100%;min-width: 600px; background-color: aliceblue;">
        <!--
        <div style="padding: 0px 10px 0px 10px">
                <span class="tipTitle-collapse">
                    支付码信息 - {{inDetailData.qrSn}}
                </span>
            <el-table :data="[inDetailData]">
                <el-table-column label="类型" v-if="inDetailData.type===CST_OrderType.IN || inDetailData.type===CST_OrderType.OUT " width="80px">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.type===CST_OrderType.OUT" color="#FFFFFF">出库</el-tag>
                        <el-tag type="success" v-else color="#FFFFFF">入库</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="outAgentName" label="调出" />
                <el-table-column prop="inAgentName" label="调入" />
                <el-table-column prop="status" label="状态" width="80">
                    <template slot-scope="scope">{{_enums.DevAllotStatusEnum.getNameById(scope.row.status)}}</template>
                </el-table-column>
                <el-table-column label="操作" v-if="inDetailData.type===CST_OrderType.IN && inDetailData.status===CST_OrderStat.SEND" width="160px" align="center">
                    <template slot-scope="scope">
                        <el-button type="warning" round  size="mini" @click="confirmOrder(scope.row, CST_OrderStat.REFS)" >拒收</el-button>
                        <el-button type="primary" round  size="mini" @click="confirmOrder(scope.row, CST_OrderStat.RECV)" >签收</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div style="padding: 10px 10px 20px 10px">
            <el-steps :active="stepActive" finish-status="success">
                <el-step title="出库"></el-step>
                <el-step title="途中"></el-step>
                <el-step title="确认"></el-step>
            </el-steps>
        </div>
        -->
        <div style="height: 100%; text-align: center">
            <!--
            <span class="tipTitle-collapse">支付码</span>
            -->
            <el-button icon="el-icon-bottom" type="primary" @click="getObjectURL" style="margin-left: 10px;">支付码下载</el-button>
            <div class="cls-epay" :style="{backgroundImage:'url('+ (imgBgPayQr) +')'}" id="qrcode"> <!-- :style="{backgroundImage:'url('+ (inDetailData.dyCode?imgBgPayQr:imgEpay) +')'}" -->
                <div class="cls-name font12-c" :style="{fontSize: _p_env.VUE_APP_CSS_QR_PAY_MCH_NAME_FONT_SIZE, top: _p_env.VUE_APP_CSS_QR_PAY_MCH_NAME_FONT_TOP}">
                    <span>{{inDetailData.mchName}}</span>
                </div>
                <!-- :logoSrc=imgLogo  -->
                <vue-qr class="cls-qrcode" :text="_p_env.VUE_APP_URL_QR_ADDR + inDetailData.qrCode" :size="180" :margin="1"></vue-qr>
                <div class="cls-sn font10-c">
                    <span>No.{{inDetailData.qrSn}}</span>
                </div>
            </div>

            <div class="cls-epay-bottom" :style="{backgroundImage:'url('+ imgEpayBottom +')'}" >
            </div>
            <!-- 分页栏
            <div class="yx-flex-h-end">
                <el-pagination small
                               @current-change="currentChangeFA"
                               @size-change="sizeChangeFA"
                               layout="total, prev, pager, next"
                               :total="total">
                </el-pagination>
            </div>-->
        </div>
    </div>
</template>

<script>
    import vueQr from 'vue-qr'
    import html2canvas from "html2canvas"
    import {transformBase64ToBlob} from "../../utils/datatool";
    export default {
        name: "DevAllotDetailDiv",
        props:["inDetailData"],
        components: {
            vueQr
        },
        data() {
            return {
                // imgLogo: require("../../../static/img/qre-dy.png"),
                // imgEpay: require("../../../static/img/epay.png"),
                imgBgPayQr: require("@/assets/img/" + this._p_env.VUE_APP_RES_IMG_QR_PAY_BG),
                // imgBgPayQr: require("../../../static/img/epay-dy.png"),
                imgEpayBottom: require("../../../static/img/epay-bottom.png"),
                imgDyTitle: require("../../../static/img/dy-title-black.png"),
                stepActive:2,
                CST_OrderType: { OUT:'0', IN:'1' },
                CST_OrderStat: { SEND:1, RECV:2, REFS:3 },
                loading: false,
                total: 0,
                page: 1,
                size: 10,
                devAllotDetails:[]
            };
        },
        mounted() {
            this.initDevAllotDetails();
            if(this.inDetailData.status>this.CST_OrderStat.SEND) this.stepActive = 3;
        },
        methods: {
            getObjectURL (flag) {
                let that = this
                console.log("dpi", window.devicePixelRatio)
                // 点击保存
                html2canvas(document.getElementById("qrcode"),
                    {
                        backgroundColor: null,
                        scale: 8, // 按比例增加分辨率 (2=双倍).
                        dpi: 600, //window.devicePixelRatio * 10, // 处理模糊问题
                        useCORS: true // 【重要】开启跨域配置
                    }
                ).then(canvas => {
                    // this.qrImgBlob = canvas.toDataURL("image/png")
                    /** */
                     // 创建下载的链接
                     let link = document.createElement("a")
                     // 创建url
                     let href = window.URL.createObjectURL(transformBase64ToBlob(canvas.toDataURL("image/png")))
                     link.href = href
                     // 下载后文件名
                     link.download = that.inDetailData.qrSn + ".png"
                     document.body.appendChild(link)
                     // 点击下载
                     link.click()
                     // 下载完成移除元素
                     document.body.removeChild(link)
                     // 释放掉blob对象
                     window.URL.revokeObjectURL(href)

                })
            },
            sizeChangeFA(currentSize) {
                this.size = currentSize;
                this.initDevAllotDetails();
            },
            currentChangeFA(currentPage) {
                this.page = currentPage;
                this.initDevAllotDetails();
            },
            emitToParent() {
                this.$emit('update:outDrawerClose', false);
            },
            initDevAllotDetails() {
                this.loading = true;
                let url = '/dev/devAllotDetails?page=' + this.page + '&size=' + this.size;
                if (this.inDetailData.allotBatNo) {
                    url += '&allotBatNo=' + this.inDetailData.allotBatNo;
                }
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.devAllotDetails = resp.data;
                        this.total = resp.total;
                    }
                })
            }
        }
    }
</script>

<style scoped>

    .cls-epay-bottom {
        background-repeat:no-repeat;
        height: 97px;
        width: 523px;
        background-size:100% 100%;
        -moz-background-size:100% 100%;
        margin: -25px auto;
    }

    .cls-epay {
        background-repeat:no-repeat;
        height: 635px;
        width: 523px;
        background-size:100% 100%;
        -moz-background-size:100% 100%;
        margin: 0 auto;
        /*
        display: -webkit-box;
        -webkit-box-align: center;
        -webkit-box-pack: center;
         */
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: relative;
    }
    .cls-dy-title {
        position: absolute;
        top: 200px;
    }
    .cls-qrcode {
        position: absolute;
        top: 285px;
    }
    .cls-name {
        font-family: 'Microsoft YaHei', '微软雅黑', sans-serif;
        position: absolute;
        top: 245px;
        font-weight: bolder;
    }
    .cls-sn {
        font-family: 'Microsoft YaHei', '微软雅黑', sans-serif;
        position: absolute;
        top: 462px;
    }
    .font10-c {
        font-size: 12px;
        transform: scale(0.8);
        transform-origin: center;
    }
    .font12-c {
        font-size: 12px;
        transform-origin: center;
    }
    .flex-row {
        display: flex;
    }

    .flex-column {
        display: flex;
        flex-direction: column;
    }

    .flex-justify-center {
        justify-content: center;
    }

    .flex-align-center {
        align-items: center;
    }


    .flex-center {
        justify-content: center;
        align-items: center;
    }
    .flex-between {
        align-items: center;
        justify-content:space-between;
    }
    .flex-around {
        align-items: center;
        justify-content:space-around;
    }
</style>
